import { Injectable } from '@angular/core';
import { FCM } from '@capacitor-community/fcm';
import { Capacitor } from '@capacitor/core';
import {
    ActionPerformed,
    PushNotificationSchema,
    PushNotifications,
    Token
} from '@capacitor/push-notifications';
import { BodyPushNotification } from '../models/push-model/body-push-notification.model';

/**
 * Serviço de push via Firebase
 * @author Starley Cazorla
 */

@Injectable({
    providedIn: 'root',
})
export class FcmFirebaseProvider {
    session: any;

    notifications: PushNotificationSchema[] = [];

    topicName = 'acelera_movel';
    remoteToken: string = '';
    constructor() { }

    async registerPush() {
        PushNotifications.requestPermissions().then((permission) => {
            if (permission.receive === 'granted') {
                // Register with Apple / Google to receive push via APNS/FCM
                PushNotifications.register();
            } else {
                // No permission for push granted
            }
        });

        PushNotifications.addListener(
            'registration',
            (token: Token) => {
                console.log('My token: ' + JSON.stringify(token));
            }
        );

        PushNotifications.addListener('registrationError', (error: any) => {
            console.log('Error: ' + JSON.stringify(error));
        });

        PushNotifications.addListener(
            'pushNotificationReceived',
            async (notification: PushNotificationSchema) => {
                console.log('Push received: ' + JSON.stringify(notification));
            }
        );

        PushNotifications.addListener(
            'pushNotificationActionPerformed',
            async (notification: ActionPerformed) => {
                const data = notification.notification.data;
                console.log('Action performed: ' + JSON.stringify(notification.notification));
                if (data.detailsId) {
                    console.log("🚀 ~ file: fcm.service.ts:75 ~ PushNotificationService ~ data.detailsId", data.detailsId)

                }
            }
        );
    }

    /**
     * Gets token
     * @author Starley Cazorla
     */
    async getToken() {
        if (Capacitor.getPlatform() !== 'web') {
            FCM.getToken()
                .then((result: any) => {
                    this.remoteToken = result.token;
                })
                .catch((err: any) => console.log(err));

            await this.registerPush();
        }
    }

    /**
     * Gets news not read
     * @author Starley Cazorla
     * @returns
     */
    public async getNewsNotRead() {
        let listNews: BodyPushNotification[] = [];
        if (Capacitor.getPlatform() !== 'web') {
            const notificationList = (
                await PushNotifications.getDeliveredNotifications()
            ).notifications;
            if (notificationList.length > 0) {
                notificationList.forEach((notification: PushNotificationSchema) => {
                    const body: BodyPushNotification = {
                        dateDelivery: new Date(),
                        data: { title: notification.title, description: notification.body },
                    };
                    listNews.push(body);
                });
            }
        }
        return listNews;
    }

    /**
     * Removes all delivered notifications
     * @author Starley Cazorla
     * @returns
     */
    public async removeAllDeliveredNotifications() {
        return await PushNotifications.removeAllDeliveredNotifications();
    }
}



